export const s = function(x: string) {
    return x.replace(/:/g, '\\:')
}

export const textToFloat = function(x: string): number {
    const res = parseFloat(x.trim().replace(/,/g, ''))
    if (isNaN(res)) {
        console.warn(`${x} is a NaN. Returning 0 instead`)
        return 0
    } else {
        return res
    }
}

export const hash = function(str: string): string {
    let hash = 0, i, chr
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + chr
        hash |= 0 // Convert to 32bit integer
    }
    return hash.toString()
}

export function groupBy<T, U>(list: T[], keyGetter: (x: T) => U): Map<U, T[]> {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}